/* eslint-disable no-nested-ternary */
// export const calculatePercentageVariation = (arrayOfLengths) =>
//   arrayOfLengths.slice(1).map((currentLength, index) => {
//     const prevLength = arrayOfLengths[index];
//     const percentage = (prevLength * 100) / currentLength - 100;
//     return percentage;
//   });
export const calculatePercentageVariation = (arrayOfLengths) =>
  arrayOfLengths.slice(1).map((currentLength, index) => {
    const prevLength = arrayOfLengths[index];
    const percentage =
      currentLength === 0 && prevLength > 0
        ? 100
        : currentLength === 0
        ? 0
        : prevLength === 0
        ? 100
        : (prevLength * 100) / currentLength - 100;
    return percentage;
  });
